export const all_routes = {
  home: "/index",
  signup: "/authentication/register",
  login: "/authentication/login",
  forgotpassword: "/authentication/forgot-password",
  resetpassword: "/authentication/reset-password",
  aboutus: "/aboutus",
  listinggrid: "/listing-grid",
  listinglist: "/listing-list",
  pricing: "/pages/pricing",
  faq: "/pages/faq",
  gallery: "/pages/gallery",
  bloglist: "/blog/blog-list",
  bloggrid: "/blog/blog-grid",
  blogdetails: "/blog/blog-details",
  listingdetails: "/listing-details",
  bookingcheckout: "/booking-payment",
  booking: "/booking",
  invoice: "/invoice-details",
  ourteam: "/our-team",
  testimonial: "/testimonial",
  termsconditions: "/terms-condition",
  privacypolicy: "/privacy-policy",
  cookies: "/cookies-policy",
  gdpr: "/gdpr",
  maintenance: "/maintenance",
  comingsoon: "/coming-soon",
  error404: "/error-404",
  error500: "/error-500",
  contact: "/contact",
  admin: "/admin",
  addCar: "/admin/add-car",
  editCar: "/admin/edit-car/:carId",
  carRequest: "/car-request",
};
